import { AppEnv, publicRuntimeConfig, Region } from "@fanfanlo"

const docUrl = (() => {
    switch (publicRuntimeConfig.region) {
        case Region.GLOBAL:
            switch (publicRuntimeConfig.env) {
                case AppEnv.Dev:
                    return 'http://192.168.177.180:10222/'
                case AppEnv.Prod:
                    return 'https://droid-docs.vercel.app/'
                default:
                    return 'https://droid-docs.vercel.app/'
            }
        case Region.CN:
            return 'http://192.168.177.180:10222/'
        default:
            return 'https://droid-docs.vercel.app/'
    }
})()

export const browserConf = {
    docUrl
}


export const browserUtils = {
    getUrl:(path:string) =>{
        return `${docUrl}${path}`
    }
}
